import React, { Component } from "react";
import Ambassadrice from "./Ambassadrice";

class Ambassadrices extends Component {
  state = {};
  componentDidMount() {}
  componentDidUpdate() {
    if (
      this.props.ambassadrices.length === 0 &&
      !document.querySelector(".alert-newsletter .formulaire_ville")
    ) {
      let form = document.querySelector("#base").cloneNode(true);
      form.removeAttribute("id");
      form.removeAttribute("hidden");
      document.querySelector(".alert-newsletter").appendChild(form);
    }
  }
  render() {
    return (
      <div className="sidebar wow fadeInLeft">
        <aside className="sidebar_page">
          <h1>
            <strong>Trouvez</strong> votre <br /> ambassadrice ou <br />
            votre ambassadeur
            <br />
            dans le monde
          </h1>
          <div className="recherche">
            <form className="search-form">
              <label>
                <input
                  onChange={this.props.handleSearch}
                  className="search-field"
                  placeholder="Renseignez votre département"
                  //value=""
                  //name="s"
                  type="search"
                  maxLength="2"
                />
              </label>
              <div style={{fontStyle: 'italic', fontSize: '11px', marginTop: '10px'}}>tapez 99 pour trouver une ambassadrice  - ambassadeur hors France</div>
              {/* <input className="search-submit" value="ok" type="submit" /> */}
            </form>
          </div>
          {this.props.ambassadrices.length === 0 ? (
            <div className="form-result">
              <p>
                Oups, j'ai comme l'impression <br /> qu'il n'y a personne ici...
              </p>
              <div className="alert-newsletter">
                <p>
                  <strong>Je souhaite être informé.e</strong> quand
                  <br /> une ambassadrice ou un ambassadeur MMM
                  <br /> s'installe dans ma <strong>Ville</strong>
                </p>
              </div>
            </div>
          ) : (
            <div className="list-container">
              <ul className="list">
                {this.props.ambassadrices.map(a => (
                  <Ambassadrice
                    key={a.id}
                    ambassadrice={a}
                    showContent={this.props.showContent}
                    handleMouseEnter={this.props.handleMouseEnter}
                    handleMouseLeave={this.props.handleMouseLeave}
                  />
                ))}
              </ul>
            </div>
          )}
        </aside>
      </div>
    );
  }
}

export default Ambassadrices;



// WEBPACK FOOTER //
// ./src/Components/Ambassadrices.jsx